var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75c0 .414.336.75.75.75h12a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0-.75.75zm2.9-4.5a.75.75 0 0 0 0 1.5h7.737a.75.75 0 0 0 0-1.5H5.15zM3 4.5A.75.75 0 0 0 3 6h12a.75.75 0 0 0 0-1.5H3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/alignCenter.85862fb61c698c99acc32cb9db7ad459.svg";
export { ForwardRef as ReactComponent };